import 'reflect-metadata';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import { createApp } from 'vue';
import router from './Router';
import App from './templates/App.vue';
import VueCookies from 'vue-cookies';
import { createVfm } from 'vue-final-modal';
import { createHead } from '@unhead/vue';
import { init as sentryInit, browserTracingIntegration, captureException } from '@sentry/vue';

/**
 * Include extensions. Otherwise, runtime error will occur
 *
 * @todo - Mutating prototypes is considered a bad practice in JS / TS
 *         Not only can it cause unexpected conflicts, but it also effectively
 *         makes these functions "global variables", and it's an implicit / indirect
 *         dependency that ends up not being defined as an import in a file.
 *         This can additionally code splitting to not work effectively, because
 *         more things have a global scope.
 */
import './scripts/shared/extensions/NumberExtensions';
import './scripts/shared/extensions/StringExtensions';
import './scripts/shared/extensions/EventExtensions';
import './scripts/shared/extensions/fetch';

import ClipboardJS from 'clipboard';

new ClipboardJS('.copy-button-wrapper');

const app = createApp(App);
const head = createHead();
app.use(createVfm());
app.use(head);

sentryInit({
  app,
  environment: import.meta.env.MODE,
  dsn: 'https://cea51c0818ef618eb53d402240a0f338@o4509413391007744.ingest.us.sentry.io/4510268414099456',
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
  integrations: [
    browserTracingIntegration({ router }),
  ],
  // Tracing
  tracesSampleRate: 1.0, // Capture 100% of the transactions
});

app.config.errorHandler = (err: any) => {
  if (err instanceof Error) {
    captureException(err);
  } else if (err && err?.responseStatus?.message) {
    captureException(new Error(err?.responseStatus?.message ?? err));
  } else {
    captureException(new Error(err?.message ?? err));
  }
  console.error(err?.message ?? err);
};

app.use(VueCookies);
app.use(router).mount('#app');
